import clsx from 'clsx';
import styles from './pages.module.scss';
import WrappedSvg from '../../../../../assets/svg/wrapped/queue.svg';
import dayjs from 'dayjs';


const Queue = ({ queue: queueProp }) => {
  const {queue, bestDay} = queueProp;

  return (
    <div className={styles.card}>
        <img src={WrappedSvg} alt='Wrapped' className={styles.background_image} />
        <div className={styles.title_container}>
          <h1 className={clsx(styles.title, styles.title_min)}>Clienti totali <br/> in lista {"d'attesa"}</h1>
          <h1 className={styles.value_queue}>{queue || 0}</h1>
          {bestDay && <><h1 className={clsx(styles.title, styles.title_min)}>Giorno con <br/> maggiore richiesta</h1>
          <h1 className={styles.value_queue}>{dayjs(bestDay.dataListaAttesa).format('DD MMMM') || '01 Gen'}</h1>
          </>}
        </div>
    </div>
  );
};

export default Queue;
